<template>
  <div v-if="$route.params.query" class="modal fade" id="shareResult" tabindex="-1" role="dialog"  aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="color-line"></div>
        <div class="modal-header" style="padding: 20px 15px;">
          <h4 class="modal-title m-b-md">Share Results query  with a colleague</h4>
         </div>
        <form v-on:submit="share">

           <div class="modal-body">
             <div class="form-group">
               <label class="control-label required" for="from">From:</label>
               <input v-model.trim="from" type="text" placeholder="Enter your email address"
                      title="" value="" name="from" id="from"
                      class="form-control">
               <span v-if="errorFrom" class="help-block text-danger">{{this.errorFrom}}</span>
             </div>
             <div class="form-group">
               <label class="control-label required" for="to">To:</label>
               <input v-model.trim="to" type="text" placeholder="Enter email address"
                      title="" value="" name="to" id="to"
                      class="form-control">
               <span v-if="errorTo" class="help-block text-danger">{{this.errorTo}}</span>
             </div>
             <div class="form-group">
               <label class="control-label required" for="subject">Subject:</label>
               <input v-model.trim="subject" type="text" placeholder="Enter email address"
                      title="" value="" name="subject" id="subject"
                      class="form-control">
               <span v-if="errorTo" class="help-block text-danger">{{this.errorSubject}}</span>
             </div>
             <div class="form-group">
               <label class="control-label required" for="message">Message:</label>
               <summernote v-model="message" :air-mode="false" id="message" name="message" :height="'250'"></summernote>
               <span class="help-block m-b-none hide">Message can make 255 character</span>
               <span v-if="errorMessage" class="help-block text-danger">{{this.errorMessage}}</span>
             </div>

             <div style="text-align: right;margin-top: 10px">
               <span style="font-style: italic;font-size: 12px">(<span style="color: red">*</span>) required fields</span>
             </div>

           </div>
           <div class="modal-footer">
             <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
             <vue-ladda type="submit" :loading="submit.loading" class="btn btn-info" :data-style="submit.dataStyle">Share</vue-ladda>
           </div>
         </form>

      </div>
    </div>
  </div>
</template>

<script>

import VueLadda from 'vue-ladda'
import Summernote from '../utils/Summernote'

export default {
  components: {
    VueLadda,
    Summernote
  },
  props: ['value', 'queryData'],
  name: 'ShareSearchResult',
  methods: {
    share: function (event) {
      event.preventDefault()
      this.submit.loading = true
      let data = {
        from: this.from,
        to: this.to,
        subject: this.subject,
        message: this.message
      }
      this.axios.post('/search/result/share', data)
        .then((response) => {
          $('#shareResult').modal('hide')

          this.to = null
          this.message = null
          this.subject = null
          this.errorTo = null
          this.errorSubject = null
          this.errorMessage = null
          this.$notify({
            type: 'success',
            title: 'Result has been shared successfully',
            placement: 'bottom-right'
          })
          if (typeof this.refresh !== 'undefined') {
            this.refresh(this.$moment().format())
          }
          this.$salesMachine.shareResult({query: this.$route.params.query, message: this.message})
        })
        .catch((error) => {
          if (error.response.status === 400) {
            let errors = error.response.data.errors
            switch (error.response.data.code) {
              case 1:
                this.errorTo = errors['to'][0]
                break
              case 2:
                this.errorSubject = errors['subject'][0]
                break
              case 3:
                this.errorMessage = errors['message'][0]
                break
              case 4:
                this.errorFrom = errors['from'][0]
                break
            }
          } else {
            this.$notify({
              type: 'error',
              title: 'An error occurred during Sharing Resuts! Please try again or refresh the current page.',
              placement: 'bottom-right'
            })
          }
        })
        .finally(() => {
          this.submit.loading = false
        })
    }
  },
  data () {
    return {
      from: null,
      to: null,
      message: null,
      subject: null,
      errorFrom: null,
      errorTo: null,
      errorSubject: null,
      errorMessage: null,
      submit: {
        loading: false,
        'dataStyle': 'zoom-in'
      }
    }
  },
  mounted () {
    $('#shareResult').modal()
    $('#shareResult').on('hidden.bs.modal', (e) => {
      this.$emit('input', false)
    })
  },
  beforeMount () {
    let queryCleaned = this.$route.params.query.replace(/<\/?[^>]+(>|$)/g, '').replace('/"/g', '')
    this.message = ' Hi, <br> I have found this list of experts on (' + queryCleaned + ') that might interest you.'
    this.message += '<br> ---------------------------------------------------'
    this.message += '<br><br> <b>Link: </b> <a href="' + window.location.href + '">' + this.$route.params.query + '</a>'
    this.message += '<br><br> ---------------------------------------------------'
    this.message += '<br> Regards, <br>'
    this.message += (typeof this.$auth.user().id !== 'undefined') ? this.$auth.user().firstName + ' ' + this.$auth.user().lastName + '<br>' : ''
    if (this.$user.isSe()) {
      this.message += 'Source: LEA platform'
    } else if (this.$user.isOrange()) {
      this.message += 'Source: CROP platform'
    } else {
      this.message += 'Source: Idexlab platform'
    }

    this.subject = 'Share Results: ' + queryCleaned
    this.from = (typeof this.$auth.user().id !== 'undefined') ? this.$auth.user().email : null
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modal/ShareSearchResult.vue